import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

const initialState = null;

const staffLastEvaluatedKeyReducer = createSlice({
	name: 'staffLastEvaluatedKey',
	initialState: null,
	reducers: {
		setStaffLastEvaluatedKeyData(state, action) {
			return action.payload;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(revertAll, () => initialState);
	},
});

export const { setStaffLastEvaluatedKeyData } = staffLastEvaluatedKeyReducer.actions;
export default staffLastEvaluatedKeyReducer;
